import ModelGroup from './ModelGroup'
import EquipmentGraphics from './EquipmentGraphics'
import BaseEntity from '../baseclasses/BaseEntity'
export class Model extends BaseEntity {
    ID: number;
    ModelGroupID?: number;
    ModelGroup?: ModelGroup;
    Name?: string;
    MaterialNumber?: string;
    CONAModelGroup?: string;
    EquipmentGraphics?: EquipmentGraphics[];
    EquipmentGraphicsCount?: number;
    Inactive?: boolean;
    AllowTopper?: boolean;
    RequireCoolerDoor?: boolean;
    RequireApproval?: boolean;
    NumberOfFlavorsRequired?: number;
}

export default Model;